import {Platform} from 'react-native';
import {getBottomSpace} from 'react-native-iphone-screen-helper';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import FastImage from 'react-native-fast-image';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  flex: 1;
`;

export const ContentTitles = styled.View`
  padding: 0 24px;
`;

export const LinkButtonContainer = styled.View`
  flex-direction: row;
  margin-bottom: ${RFValue(20)}px;
  margin-top: -${RFValue(8)}px;
`;

export const IndicationItem = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-style: solid;

  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border};
  padding: 0 24px;
  margin-bottom: ${RFValue(12)}px;
  padding-bottom: ${RFValue(12)}px;
`;

export const IndicationColumn = styled.View`
  flex-direction: row;
  margin-right: ${RFValue(12)}px;
  align-items: center;
  flex: 1;
`;

export const IndicationActions = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const IndicationInfos = styled.View`
  flex: 1;
  margin-left: ${RFValue(12)}px;
`;

export const IndicationName = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};

  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const IndicationDescription = styled.Text`
  font-size: ${RFValue(10)}px;

  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const IndicationButton = styled.TouchableOpacity`
  justify-content: center;
  margin-right: ${RFValue(10)}px;
  align-items: center;
`;
export const IndicationIcon = styled(MaterialCommunityIcons)`
  font-size: ${RFValue(22)}px;
  color: ${({theme}) => theme.colors.primary};
`;

export const IndicationButtonText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(9)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const SwitchTitle = styled.Text`
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  margin-bottom: ${RFValue(4)}px;
`;

export const Footer = styled.View`
  padding: 0 24px;
  margin-top: ${RFValue(6)}px;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? 0
    : RFValue(20)}px;
`;

export const SwitchContainer = styled.View``;
export const SwitchButton = styled.Switch``;

export const IndicationFooter = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const ProgressBarContainer = styled.View`
  padding: 0 24px;
`;

export const DesativatedListButtonContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  margin-bottom: ${RFValue(12)}px;
  z-index: 301;
`;

export const BalanceImage = styled(FastImage)`
  width: ${RFValue(14)}px;
  height: ${RFValue(14)}px;
  margin-right: ${RFValue(4)}px;
`;

export const BalanceInfo = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const Balance = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};

  line-height: ${RFValue(22)}px;
`;

export const IndicationCount = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const NextLimitContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-top-width: 1px;
  border-top-color: ${({theme}) => theme.colors.border};
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border};
  padding: ${RFValue(12)}px 0;
  margin: ${RFValue(12)}px 0;
`;
export const NextLimitTitle = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;
export const NextLimit = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;
